/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Auto_FormatInputs */



/**
* | output |
* | --- |
* | "Auto format the currently selected event based on the Event Group Settings" |
*
* @param {Shortcut_Keys_Desc_Auto_FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_auto_format = /** @type {((inputs?: Shortcut_Keys_Desc_Auto_FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Auto_FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formater automatiquement l'evenement selectionne selon les parametres du groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das aktuell ausgewählte Ereignis wird automatisch anhand der Ereignisgruppeneinstellungen formatiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formatta automaticamente l'evento attualmente selezionato in base alle impostazioni del gruppo eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое форматирование выбранного события на основе настроек группы событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formatear automáticamente el evento seleccionado actualmente según la configuración del grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根据事件组设置自动格式化当前选定的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループ設定に基づいて現在選択されているイベントを自動フォーマットします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप सेटिंग्स के आधार पर वर्तमान में चयनित इवेंट को स्वचालित रूप से फॉर्मेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatar automaticamente o evento selecionado com base nas configurações do grupo de eventos.")
	return /** @type {LocalizedString} */ ("Auto format the currently selected event based on the Event Group Settings")
});